module.exports = __webpack_public_path__ + "static/media/app_store.d26c20ef.png";